var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[(_vm.$router.currentRoute.name === 'map')?_c('div',[_c('SensorMap')],1):_c('div',{staticClass:"d-flex flex-column h-100",attrs:{"id":"app"}},[_c('AppHeader'),_c('main',{staticClass:"flex-shrink-0 container-fluid px-5 px-sm-2"},[_c('router-view')],1),_c('AppFooter')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }